import { useState, useCallback } from 'react';
import { ColumnSizingState, VisibilityState } from '@tanstack/react-table';
import { gridContextPersistenceService } from './gridContextPersistence.service';

export const useColumnSizingAndVisibility = ({
  gridName,
  defaultVisibilityState = {},
  defaultSizingState = {},
}: {
  gridName?: string;
  defaultVisibilityState?: VisibilityState;
  defaultSizingState?: ColumnSizingState;
}) => {
  const persistedVisibilityConfig = !gridName
    ? null
    : gridContextPersistenceService.getGridPersistanceStorage(gridName)?.visibility;

  const persistedSizingConfig = !gridName
    ? null
    : gridContextPersistenceService.getGridPersistanceStorage(gridName)?.sizing;

  const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(
    persistedVisibilityConfig ?? defaultVisibilityState,
  );

  const [columnSizing, setColumnSizing] = useState<ColumnSizingState>(persistedSizingConfig ?? defaultSizingState);

  const handleSetColumnVisibility = useCallback(
    (updatedVisibilityState: Record<string, boolean>) => {
      if (gridName) {
        gridContextPersistenceService.saveVisibilityToGridPersistanceStorage(gridName, updatedVisibilityState);
      }
      setColumnVisibility(updatedVisibilityState);
    },
    [gridName],
  );

  const handleSetColumnSizing = useCallback(
    (updatedVisibilityState: ColumnSizingState) => {
      if (gridName) {
        gridContextPersistenceService.saveSizingToGridPersistanceStorage(gridName, updatedVisibilityState);
      }
      setColumnSizing(updatedVisibilityState);
    },
    [gridName],
  );

  return {
    columnVisibility,
    setColumnVisibility: handleSetColumnVisibility,
    columnSizing,
    setColumnSizing: handleSetColumnSizing,
  };
};
